import { SharedState } from '$utils/sharedState.svelte';
import type { ToastProps } from '$components/toast-manager';

class StateToast extends SharedState<ToastProps> {}

export const stateToast = new StateToast(null);
